module.exports = __webpack_public_path__ + "img/CHEVRON_LEFT.1da8dcda.svg";